import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import PROVIDER_NOTIFICATION_PREFERENCES from '../queries/provider-notification-preferences.graphql';
import ProviderJoinRequestAction from './ProviderJoinRequest';

const Actions = ({ consultation, currentUser: { roleCd }}) => {
  const [notificationPreferences, setNotificationPreferences] = useState([]);
  const [showNotifyProvider, setShowNotifyProvider] = useState(false);
  const { providerId, specialtyCd: specialtyCode } = consultation;

  const [loadNotificationPreferences] = useLazyQuery(PROVIDER_NOTIFICATION_PREFERENCES, {
    variables: { id: parseInt(providerId), specialtyCodes: [specialtyCode] },
    fetchPolicy: 'network-only',
    onCompleted: ({ provider: { notificationPreferences: preferences } }) => {
      setNotificationPreferences(preferences);
    }
  });

  useEffect(() => {
    if (consultation) {
      loadNotificationPreferences();
    }
  }, [consultation]);

  useEffect(() => {
    setShowNotifyProvider('ATTENDEEROLE_MA' === roleCd);
  }, [roleCd]);

  return (
    <div>
      {
        showNotifyProvider && (
          <ProviderJoinRequestAction
            consultation={consultation}
            notificationPreferences={notificationPreferences}
          />
        )
      }
    </div>
  );
};

Actions.propTypes = {
  consultation: PropTypes.object,
  roleCd: PropTypes.string,
  currentUser: PropTypes.shape({
    roleCd: PropTypes.string
  })
};

export default Actions;
